import React from 'react';

import { Box, Link, Typography } from '@mui/material';

import useSelfService from '../../../hooks/useSelfService';
import { Constants } from '../../../helpers/Constants';
import strings from '../../../localization';

import classes from './styles';

const defaultProps = {};

const SignupHeader = () => {
  const { isSelfService } = useSelfService();
  let label = `${strings.pharma}${strings.plan}`;

  if (isSelfService) {
    label = strings.pharmagap;
  }

  return (
    <Box component="div" sx={classes.container}>
      <Box component="div" sx={classes.joinTextContainer}>
        <Typography component="span" sx={classes.joinText}>
          {strings.join}
        </Typography>
        <Typography component="span" sx={classes.pharmaPlanText}>
          {label}
        </Typography>
        <Box component="div">
          <Typography component="span" sx={classes.alreadyMemberText}>
            {strings.alreadyMember}
            <Link
              href={Constants.paths.login}
              underline="hover"
              sx={classes.loginText}
            >
              {strings.login}
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
SignupHeader.defaultProps = defaultProps;

export default SignupHeader;
